export const getEnv = location => {
    if (location && location.hostname) {
        if (location.hostname === 'ga.secondchancebonuszone.com') {
            return 'prod';
        } else if (location.hostname === 'ga.uat.secondchancebonuszone.com') {
            return 'uat';
        } else if (location.hostname === 'ga.qa.secondchancebonuszone.com') {
            return 'qa';
        } else if (
            location.hostname === 'localhost' ||
            location.hostname === '0.0.0.0' ||
            location.hostname === '127.0.0.1'
        ) {
            return 'dev';
        }
    }
    return 'prod';
};
